import Repository from '@/app/shared/infrastructure/http/Repository';

export default class ClientRepository extends Repository {
    uri = '/api/clients'
}
